module.exports = __webpack_public_path__ + "img/handraw_panier orange .af5c86c8.svg";